import script from "./DisclosureCounselingReportView.vue?vue&type=script&setup=true&lang=js"
export * from "./DisclosureCounselingReportView.vue?vue&type=script&setup=true&lang=js"

import "./DisclosureCounselingReportView.vue?vue&type=style&index=0&id=526b56a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-526b56a6"]])

export default __exports__